import types from '../mutation-types';
import AccountScheduledMessagesAPI from '../../api/accountScheduledMessages';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getAll(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async getAll({ commit }, { status, inboxId, authorId, limit } = {}) {
    commit(types.SET_ACCOUNT_SCHEDULED_MESSAGES_UI_FLAG, { isFetching: true });
    try {
      const { data } = await AccountScheduledMessagesAPI.getAll({
        status,
        inboxId,
        authorId,
        limit,
      });
      commit(types.SET_ACCOUNT_SCHEDULED_MESSAGES, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_ACCOUNT_SCHEDULED_MESSAGES_UI_FLAG, {
        isFetching: false,
      });
    }
  },

  async create({ commit }, { payload }) {
    commit(types.SET_ACCOUNT_SCHEDULED_MESSAGES_UI_FLAG, { isCreating: true });
    try {
      const { data } = await AccountScheduledMessagesAPI.create(payload);
      commit(types.ADD_ACCOUNT_SCHEDULED_MESSAGE, data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_ACCOUNT_SCHEDULED_MESSAGES_UI_FLAG, {
        isCreating: false,
      });
    }
  },

  async update({ commit }, { id, payload }) {
    commit(types.SET_ACCOUNT_SCHEDULED_MESSAGES_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await AccountScheduledMessagesAPI.update(id, payload);
      commit(types.UPDATE_ACCOUNT_SCHEDULED_MESSAGE, data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_ACCOUNT_SCHEDULED_MESSAGES_UI_FLAG, {
        isUpdating: false,
      });
    }
  },

  async delete({ commit }, { id }) {
    commit(types.SET_ACCOUNT_SCHEDULED_MESSAGES_UI_FLAG, { isDeleting: true });
    try {
      await AccountScheduledMessagesAPI.delete(id);
      commit(types.DELETE_ACCOUNT_SCHEDULED_MESSAGE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_ACCOUNT_SCHEDULED_MESSAGES_UI_FLAG, {
        isDeleting: false,
      });
    }
  },
};

export const mutations = {
  [types.SET_ACCOUNT_SCHEDULED_MESSAGES_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.SET_ACCOUNT_SCHEDULED_MESSAGES]($state, data) {
    $state.records = data;
  },

  [types.ADD_ACCOUNT_SCHEDULED_MESSAGE]($state, data) {
    $state.records.unshift(data);
  },

  [types.UPDATE_ACCOUNT_SCHEDULED_MESSAGE]($state, data) {
    const index = $state.records.findIndex(record => record.id === data.id);
    if (index > -1) {
      $state.records.splice(index, 1, data);
    }
  },

  [types.DELETE_ACCOUNT_SCHEDULED_MESSAGE]($state, id) {
    $state.records = $state.records.filter(record => record.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
